module.exports = __webpack_public_path__ + "img/2.00b5a2f.png";